import {mountGlide} from "./glide-mount.js";

const airportToggleButtons = document.getElementById('airportToggleButtons');
const airportContentContainer = document.getElementById('airports');

if (airportToggleButtons && airportContentContainer) {

    const toggleButtons = Array.from(airportToggleButtons.children);
    const airportContent = Array.from(airportContentContainer.children);

    // Collapse all except from first
    airportContent.forEach(function(child, index) {
        if (index !== 0) child.classList.add('collapsed');
        mountGlide();
    });

    toggleButtons.forEach(function(child, index) {
        let airportId = child.getAttribute('data-airport-id');
        let airport = document.getElementById('airport-' + airportId);

        if (index !== 0) {

            child.addEventListener('click', function() {
                collapseAll();
                airport.classList.remove('collapsed');
                child.classList.add('active');
                mountGlide();
            });

            function collapseAll() {
                toggleButtons.forEach(function(child) {
                    child.classList.remove('active');
                });

                airportContent.forEach(function(child) {
                    child.classList.add('collapsed');
                });
            }
        }
    });
}

